import { StatsigClient } from '@statsig/js-client'

export const STATSIG_KEY = Symbol('statsig')

export interface StatsigPlugin {
  client: StatsigClient
}